import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import TextAreaInput from "../../common/TextAreaInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";

import * as domainConstants from "../../../constants/DomainConstants";

const BehoefteForm = props => {

    const OMGEVINGSANALYSE_TOOLTIP = "Maak een onderscheid volgens doelgroep, d.i. de door de Vlaamse overheid ondersteunde topsportprogramma’s per topsportfederatie (talentdetectie-, ontwikkelings- en/of prestatieprogramma’s).";
    const {
        beoordelingscriteria,
        disabled,
        errors,
        onChange,
        color,
        fileTypes,
        mapDeleteFile,
        mapDropFiles,
        getFilesForDossierComponent,
        fileSessionStarted,
        validationMessageType
    } = props;

    return (
        <Fieldset
            title="Behoefte">
            <FieldsetSubHeader>Toon aan hoe de investering zal bijdragen aan het huidige en toekomstige topsportlandschap, daarbij een meerwaarde biedend voor de Vlaamse topsporters en topsporttalenten of voor het voeren van een integraal Vlaams topsportbeleid. Beschrijf daarbij in welke mate de Vlaamse topsportfederaties behoefte hebben aan en gebruik wensen te maken van de betreffende sportinfrastructuur.</FieldsetSubHeader>
            <TextAreaInput
                name="omgevingsAnalyse"
                label="Omgevingsanalyse (max. 15.000 tekens)"
                value={beoordelingscriteria.omgevingsAnalyse}
                onChange={onChange}
                height={5}
                disabled={disabled}
                tooltip={OMGEVINGSANALYSE_TOOLTIP}
                validationMessage={errors ? errors.omgevingsAnalyse : ""}
                validationMessageType={validationMessageType} />
            <DownloadUploadFiles
                dossierId={beoordelingscriteria.dossierId}
                title="Impact op het topsportlandschap"
                center
                optional
                disabled={disabled}
                color={color}
                tab={domainConstants.DocumentTab.Criteria}
                component={domainConstants.ComponentName.ImpactTopsportlandschap}
                onDelete={mapDeleteFile(domainConstants.ComponentName.ImpactTopsportlandschap)}
                onDrop={mapDropFiles(domainConstants.ComponentName.ImpactTopsportlandschap)}
                files={getFilesForDossierComponent(domainConstants.ComponentName.ImpactTopsportlandschap)}
                fileTypes={fileTypes.ImpactTopsportlandschap}
                validationMessage={errors ? errors.ulImpactTopsportLandschap : ""}
                validationMessageType={validationMessageType}
                fileSessionStarted={fileSessionStarted} />

        </Fieldset>
    );
};

BehoefteForm.propTypes = {
    beoordelingscriteria: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fileTypes: PropTypes.object,
    mapDeleteFile: PropTypes.func.isRequired,
    mapDropFiles: PropTypes.func.isRequired,
    getFilesForDossierComponent: PropTypes.func.isRequired,
    fileSessionStarted: PropTypes.bool,
    validationMessageType: PropTypes.string
};

export default BehoefteForm;


